import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import emailjs from '@emailjs/browser';

const THEME = {
  primary: 'text-[#2B2B2B]',
  accent: 'text-[#0070F3]',
  bg: 'bg-white',
  headerBg: 'bg-[#f7f7f8]',
  rounded: 'rounded-2xl',
};

// Çeviri sistemi
const translations = {
  TR: {
    nav: {
      home: 'ANA SAYFA',
      about: 'HAKKIMIZDA',
      products: 'ÜRÜNLER',
      sectors: 'SEKTÖRLER',
      quality: 'KALİTE & SERTİFİKA',
      contact: 'İLETİŞİM'
    },
    home: {
      hero: {
        title1: 'Endüstriyel Kalitenin',
        title2: 'Silikonla',
        title3: 'Buluştuğu Adres',
        description: 'Efor Kablo Profil, silikon bazlı çözümlerle dış cephe fitillerinden beyaz eşya contalarına kadar geniş ürün gamında yüksek kaliteyi, esnek üretimi ve hızlı teslimatı bir arada sunar.',
        button1: 'Ürünlerimizi İnceleyin',
        button2: 'Teklif Alın'
      },
      features: {
        title: 'Neden Efor Kablo?',
        prototype: '72 Saatte Prototip',
        prototypeDesc: 'Hızlı test ve onay süreçleriyle prototip imkanı. Müşteri taleplerinize hızla yanıt veriyoruz.',
        certified: 'Sertifikalı Hammadde',
        certifiedDesc: 'IEC 60529, RoHS, REACH uyumlu malzemeler. Kalite standartlarında hiç taviz vermiyoruz.',
        eco: 'Çevreye Duyarlı',
        ecoDesc: 'Atıkları geri dönüştüren, enerji verimli tesisler. Sürdürülebilir üretim anlayışımız.'
      },
      categories: {
        title: 'Ürün Kategorilerimiz',
        facade: 'Dış Cephe Fitilleri',
        facadeDesc: 'Enerji verimli ve UV dayanımlı sistemler',
        appliance: 'Beyaz Eşya Contaları',
        applianceDesc: 'Fırın ve bulaşık makinesi contalarında yüksek sızdırmazlık',
        profiles: 'Silikon Profiller',
        profilesDesc: 'Özel kesit ve makaron çözümleri'
      },
      cta: {
        title: 'Projeniz İçin Teklif Alın',
        description: 'Uzman ekibimiz size en uygun çözümü sunmak için burada',
        button1: 'Hemen İletişime Geçin',
        button2: 'Ürün Kataloğu'
      },
      cardButton: 'Detayları Gör'
    }
  },
  EN: {
    nav: {
      home: 'HOME',
      about: 'ABOUT US',
      products: 'PRODUCTS',
      sectors: 'SECTORS',
      quality: 'QUALITY & CERTIFICATES',
      contact: 'CONTACT'
    },
    home: {
      hero: {
        title1: 'Where Industrial Quality',
        title2: 'Meets',
        title3: 'Silicone',
        description: 'Efor Kablo Profile offers high quality, flexible production and fast delivery in a wide product range from facade seals to white goods gaskets with silicone-based solutions.',
        button1: 'Explore Our Products',
        button2: 'Get Quote'
      },
      features: {
        title: 'Why Efor Kablo?',
        prototype: '72-Hour Prototype',
        prototypeDesc: 'Rapid testing and approval processes for prototypes. We respond quickly to your customer demands.',
        certified: 'Certified Raw Materials',
        certifiedDesc: 'IEC 60529, RoHS, REACH compliant materials. We never compromise on quality standards.',
        eco: 'Environmentally Conscious',
        ecoDesc: 'Waste-recycling, energy-efficient facilities. Our sustainable production approach.'
      },
      categories: {
        title: 'Our Product Categories',
        facade: 'Facade Seals',
        facadeDesc: 'Energy efficient and UV resistant systems',
        appliance: 'White Goods Gaskets',
        applianceDesc: 'High sealing performance in oven and dishwasher gaskets',
        profiles: 'Silicone Profiles',
        profilesDesc: 'Special cross-section and macaron solutions'
      },
      cta: {
        title: 'Get Quote for Your Project',
        description: 'Our expert team is here to offer you the most suitable solution',
        button1: 'Contact Us Now',
        button2: 'Product Catalog'
      },
      cardButton: 'View Details'
    }
  },
  DE: {
    nav: {
      home: 'STARTSEITE',
      about: 'ÜBER UNS',
      products: 'PRODUKTE',
      sectors: 'SEKTOREN',
      quality: 'QUALITÄT & ZERTIFIKATE',
      contact: 'KONTAKT'
    },
    home: {
      hero: {
        title1: 'Wo Industrielle Qualität',
        title2: 'Silicone',
        title3: 'Trifft',
        description: 'Efor Kablo Profil bietet hohe Qualität, flexible Produktion und schnelle Lieferung in einem breiten Produktsortiment von Fassadendichtungen bis zu Haushaltsgeräte-Dichtungen mit silikonbasierten Lösungen.',
        button1: 'Unsere Produkte Erkunden',
        button2: 'Angebot Einholen'
      },
      features: {
        title: 'Warum Efor Kablo?',
        prototype: '72-Stunden Prototyp',
        prototypeDesc: 'Schnelle Test- und Genehmigungsprozesse für Prototypen. Wir reagieren schnell auf Ihre Kundenanforderungen.',
        certified: 'Zertifizierte Rohmaterialien',
        certifiedDesc: 'IEC 60529, RoHS, REACH konforme Materialien. Wir machen nie Kompromisse bei Qualitätsstandards.',
        eco: 'Umweltbewusst',
        ecoDesc: 'Abfallrecycling, energieeffiziente Anlagen. Unser nachhaltiger Produktionsansatz.'
      },
      categories: {
        title: 'Unsere Produktkategorien',
        facade: 'Fassadendichtungen',
        facadeDesc: 'Energieeffiziente und UV-beständige Systeme',
        appliance: 'Haushaltsgeräte-Dichtungen',
        applianceDesc: 'Hohe Dichtleistung bei Ofen- und Geschirrspülmaschinen-Dichtungen',
        profiles: 'Silikon-Profile',
        profilesDesc: 'Spezielle Querschnitte und Macaron-Lösungen'
      },
      cta: {
        title: 'Angebot für Ihr Projekt Einholen',
        description: 'Unser Expertenteam ist hier, um Ihnen die beste Lösung anzubieten',
        button1: 'Jetzt Kontaktieren',
        button2: 'Produktkatalog'
      },
      cardButton: 'Details Anzeigen'
    }
  },
  FR: {
    nav: {
      home: 'ACCUEIL',
      about: 'À PROPOS',
      products: 'PRODUITS',
      sectors: 'SECTEURS',
      quality: 'QUALITÉ & CERTIFICATS',
      contact: 'CONTACT'
    },
    home: {
      hero: {
        title1: 'Où la Qualité Industrielle',
        title2: 'Rencontre',
        title3: 'le Silicone',
        description: 'Efor Kablo Profile offre une qualité élevée, une production flexible et une livraison rapide dans une large gamme de produits des joints de façade aux joints d\'électroménager avec des solutions à base de silicone.',
        button1: 'Explorer Nos Produits',
        button2: 'Demander un Devis'
      },
      features: {
        title: 'Pourquoi Efor Kablo?',
        prototype: 'Prototype en 72 Heures',
        prototypeDesc: 'Processus de test et d\'approbation rapides pour les prototypes. Nous répondons rapidement à vos demandes clients.',
        certified: 'Matériaux Bruts Certifiés',
        certifiedDesc: 'Matériaux conformes IEC 60529, RoHS, REACH. Nous ne faisons jamais de compromis sur les standards de qualité.',
        eco: 'Respectueux de l\'Environnement',
        ecoDesc: 'Installations de recyclage des déchets et efficaces en énergie. Notre approche de production durable.'
      },
      categories: {
        title: 'Nos Catégories de Produits',
        facade: 'Joints de Façade',
        facadeDesc: 'Systèmes efficaces et résistants aux UV',
        appliance: 'Joints d\'Électroménager',
        applianceDesc: 'Haute performance d\'étanchéité dans les joints de four et lave-vaisselle',
        profiles: 'Profils Silicone',
        profilesDesc: 'Sections spéciales et solutions macaron'
      },
      cta: {
        title: 'Demander un Devis pour Votre Projet',
        description: 'Notre équipe d\'experts est là pour vous offrir la solution la plus adaptée',
        button1: 'Nous Contacter',
        button2: 'Catalogue Produits'
      },
      cardButton: 'Voir Détails'
    }
  },
  RU: {
    nav: {
      home: 'ГЛАВНАЯ',
      about: 'О НАС',
      products: 'ПРОДУКЦИЯ',
      sectors: 'СЕКТОРЫ',
      quality: 'КАЧЕСТВО & СЕРТИФИКАТЫ',
      contact: 'КОНТАКТЫ'
    },
    home: {
      hero: {
        title1: 'Где Промышленное Качество',
        title2: 'Встречается с',
        title3: 'Силиконом',
        description: 'Efor Kablo Profile предлагает высокое качество, гибкое производство и быструю доставку в широком ассортименте продукции от фасадных уплотнений до прокладок бытовой техники с силиконовыми решениями.',
        button1: 'Изучить Нашу Продукцию',
        button2: 'Получить Предложение'
      },
      features: {
        title: 'Почему Efor Kablo?',
        prototype: '72-Часовой Прототип',
        prototypeDesc: 'Быстрые процессы тестирования и одобрения прототипов. Мы быстро реагируем на ваши клиентские запросы.',
        certified: 'Сертифицированные Сырьевые Материалы',
        certifiedDesc: 'Материалы, соответствующие IEC 60529, RoHS, REACH. Мы никогда не идем на компромиссы в стандартах качества.',
        eco: 'Экологически Сознательный',
        ecoDesc: 'Переработка отходов, энергоэффективные объекты. Наш устойчивый производственный подход.'
      },
      categories: {
        title: 'Наши Категории Продукции',
        facade: 'Фасадные Уплотнения',
        facadeDesc: 'Энергоэффективные и УФ-стойкие системы',
        appliance: 'Прокладки Бытовой Техники',
        applianceDesc: 'Высокая герметичность в прокладках духовок и посудомоечных машин',
        profiles: 'Силиконовые Профили',
        profilesDesc: 'Специальные сечения и макаронные решения'
      },
      cta: {
        title: 'Получить Предложение для Вашего Проекта',
        description: 'Наша команда экспертов здесь, чтобы предложить вам наиболее подходящее решение',
        button1: 'Связаться Сейчас',
        button2: 'Каталог Продукции'
      },
      cardButton: 'Посмотреть Детали'
    }
  }
};

// Footer translations
const footerTranslations = {
  TR: {
    products: 'Ürünler',
    company: 'Şirket',
    contact: 'İletişim',
    about: 'Hakkımızda',
    quality: 'Kalite & Sertifikalar',
    sectors: 'Sektörel Çözümler',
    facadeSeals: 'Dış Cephe Fitilleri',
    whiteGoods: 'Beyaz Eşya Contaları',
    siliconeProfiles: 'Silikon Profiller',
    copyright: '© 2024 Efor Kablo. Tüm hakları saklıdır.'
  },
  EN: {
    products: 'Products',
    company: 'Company',
    contact: 'Contact',
    about: 'About Us',
    quality: 'Quality & Certificates',
    sectors: 'Sectoral Solutions',
    facadeSeals: 'Facade Seals',
    whiteGoods: 'White Goods Gaskets',
    siliconeProfiles: 'Silicone Profiles',
    copyright: '© 2024 Efor Kablo. All rights reserved.'
  },
  DE: {
    products: 'Produkte',
    company: 'Unternehmen',
    contact: 'Kontakt',
    about: 'Über Uns',
    quality: 'Qualität & Zertifikate',
    sectors: 'Sektorale Lösungen',
    facadeSeals: 'Fassadendichtungen',
    whiteGoods: 'Haushaltsgeräte-Dichtungen',
    siliconeProfiles: 'Silikon-Profile',
    copyright: '© 2024 Efor Kablo. Alle Rechte vorbehalten.'
  },
  FR: {
    products: 'Produits',
    company: 'Entreprise',
    contact: 'Contact',
    about: 'À Propos',
    quality: 'Qualité & Certificats',
    sectors: 'Solutions Sectorielles',
    facadeSeals: 'Joints de Façade',
    whiteGoods: 'Joints d\'Électroménager',
    siliconeProfiles: 'Profils Silicone',
    copyright: '© 2024 Efor Kablo. Tous droits réservés.'
  },
  RU: {
    products: 'Продукция',
    company: 'Компания',
    contact: 'Контакты',
    about: 'О Нас',
    quality: 'Качество & Сертификаты',
    sectors: 'Отраслевые Решения',
    facadeSeals: 'Фасадные Уплотнения',
    whiteGoods: 'Прокладки Бытовой Техники',
    siliconeProfiles: 'Силиконовые Профили',
    copyright: '© 2024 Efor Kablo. Все права защищены.'
  }
};

// Sectors translations
const sectorsTranslations = {
  TR: {
    whiteGoods: 'Beyaz Eşya',
    construction: 'İnşaat & Cephe',
    energy: 'Endüstriyel',
    food: 'Gıda & İlaç',
    sectorImage: 'Sektör Görseli',
    whiteGoodsSector: 'Beyaz Eşya Sektörü',
    constructionSector: 'İnşaat & Cephe Sektörü',
    energySector: 'Endüstriyel Sektörler',
    foodSector: 'Gıda & İlaç Sektörü',
    whiteGoodsDesc: 'Fırın, bulaşık makinesi, çamaşır makinesi ve buzdolabı üreticileri için özel çözümler',
    constructionDesc: 'Alüminyum giydirme cephe, pencere ve kapı sistemleri için fitil çözümleri',
    energyDesc: 'Yüksek sıcaklık ve aşırı koşullar için özel silikon çözümleri',
    foodDesc: 'FDA onaylı, hijyenik üretim için özel silikon çözümleri',
    ovenDoorGaskets: 'Fırın Kapı Contaları',
    ovenDoorDesc: 'Yüksek sıcaklık dayanımı, FDA onaylı malzeme',
    dishwasherGaskets: 'Bulaşık Makinesi Contaları',
    dishwasherDesc: 'Su sızdırmazlık, kimyasal dayanım',
    washingMachineGaskets: 'Çamaşır Makinesi Contaları',
    washingMachineDesc: 'Titreşim emilimi, su geçirmezlik',
    refrigeratorGaskets: 'Buzdolabı Contaları',
    refrigeratorDesc: 'Düşük sıcaklık dayanımı, enerji verimliliği',
    aluminumFacade: 'Alüminyum Giydirme Cephe',
    aluminumFacadeDesc: 'UV dayanımlı, su sızdırmazlık sistemleri',
    historicalRestoration: 'Tarihi Restorasyon',
    historicalRestorationDesc: 'Özel renk ve form seçenekleri',
    windowSystems: 'Pencere Sistemleri',
    windowSystemsDesc: 'PVC ve alüminyum pencere fitilleri',
    doorSystems: 'Kapı Sistemleri',
    doorSystemsDesc: 'Ahşap ve metal kapı fitilleri',
    industrialOvens: 'Endüstriyel Fırınlar',
    industrialOvensDesc: 'Yüksek sıcaklık dayanımlı kapak contaları',
    automotiveMotor: 'Otomotiv Motor Bölümü',
    automotiveMotorDesc: 'Motor contaları ve sızdırmazlık sistemleri',
    powerPlants: 'Enerji Santralleri',
    powerPlantsDesc: 'Türbin ve jeneratör contaları',
    petrochemical: 'Petrokimya',
    petrochemicalDesc: 'Kimyasal dayanımlı sızdırmazlık çözümleri',
    foodProcessing: 'Gıda İşleme Makineleri',
    foodProcessingDesc: 'FDA onaylı, hijyenik contalar',
    pharmaceutical: 'İlaç Üretim Tesisleri',
    pharmaceuticalDesc: 'Steril ortam sızdırmazlık sistemleri',
    laboratory: 'Laboratuvar Ekipmanları',
    laboratoryDesc: 'Kimyasal dayanımlı contalar',
    packaging: 'Ambalaj Makineleri',
    packagingDesc: 'Gıda güvenliği standartlarına uygun'
  },
  EN: {
    whiteGoods: 'White Goods',
    construction: 'Construction & Facade',
    energy: 'Industrial',
    food: 'Food & Pharmaceutical',
    sectorImage: 'Sector Image',
    whiteGoodsSector: 'White Goods Sector',
    constructionSector: 'Construction & Facade Sector',
    energySector: 'Industrial Sectors',
    foodSector: 'Food & Pharmaceutical Sector',
    whiteGoodsDesc: 'Special solutions for oven, dishwasher, washing machine and refrigerator manufacturers',
    constructionDesc: 'Seal solutions for aluminum curtain wall, window and door systems',
    energyDesc: 'Special silicone solutions for high temperature and extreme conditions',
    foodDesc: 'Special silicone solutions for FDA approved, hygienic production',
    ovenDoorGaskets: 'Oven Door Gaskets',
    ovenDoorDesc: 'High temperature resistance, FDA approved material',
    dishwasherGaskets: 'Dishwasher Gaskets',
    dishwasherDesc: 'Waterproof, chemical resistance',
    washingMachineGaskets: 'Washing Machine Gaskets',
    washingMachineDesc: 'Vibration absorption, waterproof',
    refrigeratorGaskets: 'Refrigerator Gaskets',
    refrigeratorDesc: 'Low temperature resistance, energy efficiency',
    aluminumFacade: 'Aluminum Curtain Wall',
    aluminumFacadeDesc: 'UV resistant, waterproof systems',
    historicalRestoration: 'Historical Restoration',
    historicalRestorationDesc: 'Special color and form options',
    windowSystems: 'Window Systems',
    windowSystemsDesc: 'PVC and aluminum window seals',
    doorSystems: 'Door Systems',
    doorSystemsDesc: 'Wood and metal door seals',
    industrialOvens: 'Industrial Ovens',
    industrialOvensDesc: 'High temperature resistant door gaskets',
    automotiveMotor: 'Automotive Motor Section',
    automotiveMotorDesc: 'Motor gaskets and sealing systems',
    powerPlants: 'Power Plants',
    powerPlantsDesc: 'Turbine and generator gaskets',
    petrochemical: 'Petrochemical',
    petrochemicalDesc: 'Chemical resistant sealing solutions',
    foodProcessing: 'Food Processing Machines',
    foodProcessingDesc: 'FDA approved, hygienic gaskets',
    pharmaceutical: 'Pharmaceutical Production Facilities',
    pharmaceuticalDesc: 'Sterile environment sealing systems',
    laboratory: 'Laboratory Equipment',
    laboratoryDesc: 'Chemical resistant gaskets',
    packaging: 'Packaging Machines',
    packagingDesc: 'Compliant with food safety standards'
  },
  DE: {
    whiteGoods: 'Haushaltsgeräte',
    construction: 'Bau & Fassade',
    energy: 'Industriell',
    food: 'Lebensmittel & Pharmazie',
    sectorImage: 'Sektorbild',
    whiteGoodsSector: 'Haushaltsgeräte-Sektor',
    constructionSector: 'Bau- & Fassadensektor',
    energySector: 'Industrielle Sektoren',
    foodSector: 'Lebensmittel- & Pharmasektor',
    whiteGoodsDesc: 'Spezielle Lösungen für Ofen-, Geschirrspülmaschinen-, Waschmaschinen- und Kühlschrankhersteller',
    constructionDesc: 'Dichtungslösungen für Aluminium-Vorhangfassaden, Fenster- und Türsysteme',
    energyDesc: 'Spezielle Silikonlösungen für hohe Temperaturen und extreme Bedingungen',
    foodDesc: 'Spezielle Silikonlösungen für FDA-zugelassene, hygienische Produktion',
    ovenDoorGaskets: 'Ofentür-Dichtungen',
    ovenDoorDesc: 'Hohe Temperaturbeständigkeit, FDA-zugelassenes Material',
    dishwasherGaskets: 'Geschirrspülmaschinen-Dichtungen',
    dishwasherDesc: 'Wasserdicht, chemische Beständigkeit',
    washingMachineGaskets: 'Waschmaschinen-Dichtungen',
    washingMachineDesc: 'Schwingungsabsorption, wasserdicht',
    refrigeratorGaskets: 'Kühlschrank-Dichtungen',
    refrigeratorDesc: 'Niedrigtemperaturbeständigkeit, Energieeffizienz',
    aluminumFacade: 'Aluminium-Vorhangfassade',
    aluminumFacadeDesc: 'UV-beständige, wasserdichte Systeme',
    historicalRestoration: 'Historische Restaurierung',
    historicalRestorationDesc: 'Spezielle Farb- und Formoptionen',
    windowSystems: 'Fenstersysteme',
    windowSystemsDesc: 'PVC- und Aluminiumfensterdichtungen',
    doorSystems: 'Türsysteme',
    doorSystemsDesc: 'Holz- und Metaltürdichtungen',
    industrialOvens: 'Industrieöfen',
    industrialOvensDesc: 'Hochtemperaturbeständige Türdichtungen',
    automotiveMotor: 'Automobil-Motorbereich',
    automotiveMotorDesc: 'Motor-Dichtungen und Dichtungssysteme',
    powerPlants: 'Kraftwerke',
    powerPlantsDesc: 'Turbinen- und Generatordichtungen',
    petrochemical: 'Petrochemie',
    petrochemicalDesc: 'Chemikalienbeständige Dichtungslösungen',
    foodProcessing: 'Lebensmittelverarbeitungsmaschinen',
    foodProcessingDesc: 'FDA-zugelassene, hygienische Dichtungen',
    pharmaceutical: 'Pharmazeutische Produktionsanlagen',
    pharmaceuticalDesc: 'Sterile Umgebungsdichtungssysteme',
    laboratory: 'Laborausrüstung',
    laboratoryDesc: 'Chemikalienbeständige Dichtungen',
    packaging: 'Verpackungsmaschinen',
    packagingDesc: 'Konform mit Lebensmittelsicherheitsstandards'
  },
  FR: {
    whiteGoods: 'Électroménager',
    construction: 'Construction & Façade',
    energy: 'Industriel',
    food: 'Alimentaire & Pharmaceutique',
    sectorImage: 'Image Secteur',
    whiteGoodsSector: 'Secteur Électroménager',
    constructionSector: 'Secteur Construction & Façade',
    energySector: 'Secteurs Industriels',
    foodSector: 'Secteur Alimentaire & Pharmaceutique',
    whiteGoodsDesc: 'Solutions spéciales pour les fabricants de fours, lave-vaisselle, machines à laver et réfrigérateurs',
    constructionDesc: 'Solutions d\'étanchéité pour façades rideaux aluminium, systèmes de fenêtres et portes',
    energyDesc: 'Solutions silicone spéciales pour hautes températures et conditions extrêmes',
    foodDesc: 'Solutions silicone spéciales pour production hygiénique approuvée FDA',
    ovenDoorGaskets: 'Joints de Porte de Four',
    ovenDoorDesc: 'Résistance à haute température, matériau approuvé FDA',
    dishwasherGaskets: 'Joints de Lave-vaisselle',
    dishwasherDesc: 'Étanche, résistance chimique',
    washingMachineGaskets: 'Joints de Machine à Laver',
    washingMachineDesc: 'Absorption des vibrations, étanche',
    refrigeratorGaskets: 'Joints de Réfrigérateur',
    refrigeratorDesc: 'Résistance aux basses températures, efficacité énergétique',
    aluminumFacade: 'Façade Rideau Aluminium',
    aluminumFacadeDesc: 'Systèmes résistants aux UV, étanches',
    historicalRestoration: 'Restauration Historique',
    historicalRestorationDesc: 'Options de couleur et forme spéciales',
    windowSystems: 'Systèmes de Fenêtres',
    windowSystemsDesc: 'Joints de fenêtres PVC et aluminium',
    doorSystems: 'Systèmes de Portes',
    doorSystemsDesc: 'Joints de portes bois et métal',
    industrialOvens: 'Fours Industriels',
    industrialOvensDesc: 'Joints de porte résistants à haute température',
    automotiveMotor: 'Section Moteur Automobile',
    automotiveMotorDesc: 'Joints de moteur et systèmes d\'étanchéité',
    powerPlants: 'Centrales Électriques',
    powerPlantsDesc: 'Joints de turbine et générateur',
    petrochemical: 'Pétrochimie',
    petrochemicalDesc: 'Solutions d\'étanchéité résistantes aux produits chimiques',
    foodProcessing: 'Machines de Transformation Alimentaire',
    foodProcessingDesc: 'Joints hygiéniques approuvés FDA',
    pharmaceutical: 'Installations de Production Pharmaceutique',
    pharmaceuticalDesc: 'Systèmes d\'étanchéité d\'environnement stérile',
    laboratory: 'Équipement de Laboratoire',
    laboratoryDesc: 'Joints résistants aux produits chimiques',
    packaging: 'Machines d\'Emballage',
    packagingDesc: 'Conforme aux standards de sécurité alimentaire'
  },
  RU: {
    whiteGoods: 'Бытовая Техника',
    construction: 'Строительство & Фасад',
    energy: 'Промышленный',
    food: 'Пищевая & Фармацевтическая',
    sectorImage: 'Изображение Сектора',
    whiteGoodsSector: 'Сектор Бытовой Техники',
    constructionSector: 'Сектор Строительства & Фасада',
    energySector: 'Промышленные Секторы',
    foodSector: 'Сектор Пищевой & Фармацевтической',
    whiteGoodsDesc: 'Специальные решения для производителей духовок, посудомоечных машин, стиральных машин и холодильников',
    constructionDesc: 'Решения уплотнений для алюминиевых навесных фасадов, оконных и дверных систем',
    energyDesc: 'Специальные силиконовые решения для высоких температур и экстремальных условий',
    foodDesc: 'Специальные силиконовые решения для одобренного FDA, гигиеничного производства',
    ovenDoorGaskets: 'Уплотнения Дверцы Духовки',
    ovenDoorDesc: 'Высокая термостойкость, материал, одобренный FDA',
    dishwasherGaskets: 'Уплотнения Посудомоечной Машины',
    dishwasherDesc: 'Водонепроницаемый, химическая стойкость',
    washingMachineGaskets: 'Уплотнения Стиральной Машины',
    washingMachineDesc: 'Поглощение вибрации, водонепроницаемость',
    refrigeratorGaskets: 'Уплотнения Холодильника',
    refrigeratorDesc: 'Стойкость к низким температурам, энергоэффективность',
    aluminumFacade: 'Алюминиевый Навесной Фасад',
    aluminumFacadeDesc: 'УФ-стойкие, водонепроницаемые системы',
    historicalRestoration: 'Историческая Реставрация',
    historicalRestorationDesc: 'Специальные варианты цвета и формы',
    windowSystems: 'Оконные Системы',
    windowSystemsDesc: 'Уплотнения окон ПВХ и алюминия',
    doorSystems: 'Дверные Системы',
    doorSystemsDesc: 'Уплотнения деревянных и металлических дверей',
    industrialOvens: 'Промышленные Печи',
    industrialOvensDesc: 'Термостойкие уплотнения дверей',
    automotiveMotor: 'Автомобильный Моторный Отдел',
    automotiveMotorDesc: 'Уплотнения двигателя и системы герметизации',
    powerPlants: 'Электростанции',
    powerPlantsDesc: 'Уплотнения турбин и генераторов',
    petrochemical: 'Нефтехимия',
    petrochemicalDesc: 'Химически стойкие решения герметизации',
    foodProcessing: 'Машины Пищевой Переработки',
    foodProcessingDesc: 'Одобренные FDA, гигиеничные уплотнения',
    pharmaceutical: 'Фармацевтические Производственные Объекты',
    pharmaceuticalDesc: 'Системы герметизации стерильной среды',
    laboratory: 'Лабораторное Оборудование',
    laboratoryDesc: 'Химически стойкие уплотнения',
    packaging: 'Упаковочные Машины',
    packagingDesc: 'Соответствует стандартам безопасности пищевых продуктов'
  }
};

// Quality translations
const qualityTranslations = {
  TR: {
    productionQualityControl: 'Üretim ve Kalite Kontrol',
    qualityControlDesc: 'Her ürün 3 aşamalı kalite kontrol sürecinden geçer. Prototip aşamasından seri üretime geçişte test raporları ve müşteri onayları alınır.'
  },
  EN: {
    productionQualityControl: 'Production and Quality Control',
    qualityControlDesc: 'Every product goes through a 3-stage quality control process. Test reports and customer approvals are obtained during the transition from prototype stage to mass production.'
  },
  DE: {
    productionQualityControl: 'Produktion und Qualitätskontrolle',
    qualityControlDesc: 'Jedes Produkt durchläuft einen 3-stufigen Qualitätskontrollprozess. Testberichte und Kundenfreigaben werden beim Übergang vom Prototypenstadium zur Serienproduktion eingeholt.'
  },
  FR: {
    productionQualityControl: 'Production et Contrôle Qualité',
    qualityControlDesc: 'Chaque produit passe par un processus de contrôle qualité en 3 étapes. Les rapports de test et les approbations clients sont obtenus lors de la transition du stade prototype à la production en série.'
  },
  RU: {
    productionQualityControl: 'Производство и Контроль Качества',
    qualityControlDesc: 'Каждый продукт проходит через 3-этапный процесс контроля качества. Отчеты об испытаниях и одобрения клиентов получаются при переходе от этапа прототипа к серийному производству.'
  }
};

interface NavProps {
  onNavigate: (route: string) => void;
  current: string;
  language: string;
  onLanguageChange: (lang: string) => void;
}

function Nav({ onNavigate, current, language, onLanguageChange }: NavProps) {
  const [open, setOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  
  // Dropdown dışına tıklandığında kapat
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as HTMLElement;
      if (langOpen && !target.closest('.language-dropdown')) {
        setLangOpen(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [langOpen]);
  return (
    <header className="w-full bg-white shadow-lg border-b" style={{borderColor: '#f5f5f5'}}> 
      <div className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="flex items-center">
          <button onClick={() => onNavigate('home')} className="hover:opacity-80 transition duration-300 ml-1">
            <img src="/eforkablo_logo.png" alt="Efor Kablo Logo" className="h-16 w-auto md:h-16 sm:h-12" />
          </button>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <nav className="flex gap-8 items-center">
            {['home','about','products','sectors','quality','contact'].map(p => (
              <button
                key={p}
                onClick={() => onNavigate(p)}
                className={`relative text-sm font-medium transition duration-300 ${
                  current===p 
                    ? 'text-[#dc2626]' 
                    : 'text-gray-700 hover:text-[#dc2626]'
                }`}>
                {navLabel(p, language)}
                {current===p && (
                  <div className="absolute -bottom-2 left-0 right-0 h-0.5 bg-[#dc2626] rounded-full"></div>
                )}
              </button>
            ))}
          </nav>
          
          {/* Dil Seçimi Dropdown */}
          <div className="relative language-dropdown">
            <button
              onClick={() => setLangOpen(!langOpen)}
              className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition duration-300"
            >
              <span>{language}</span>
              <svg 
                className={`w-4 h-4 transition-transform duration-200 ${langOpen ? 'rotate-180' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            {langOpen && (
              <div className="absolute right-0 mt-2 w-20 bg-white rounded-lg shadow-lg border z-50">
                <div className="py-1">
                  {['TR', 'EN', 'DE', 'FR', 'RU'].map((lang) => (
                    <button
                      key={lang}
                      onClick={() => {
                        onLanguageChange(lang);
                        setLangOpen(false);
                      }}
                      className={`w-full text-left px-3 py-2 text-sm transition duration-200 ${
                        language === lang 
                          ? 'bg-red-50 text-[#dc2626] font-medium' 
                          : 'text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      {lang}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="md:hidden flex items-center gap-3">
          {/* Mobil Dil Seçimi */}
          <div className="relative language-dropdown">
            <button
              onClick={() => setLangOpen(!langOpen)}
              className="flex items-center space-x-1 px-2 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition duration-300"
            >
              <span>{language}</span>
              <svg 
                className={`w-3 h-3 transition-transform duration-200 ${langOpen ? 'rotate-180' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            {langOpen && (
              <div className="absolute right-0 mt-2 w-16 bg-white rounded-lg shadow-lg border z-50">
                <div className="py-1">
                  {['TR', 'EN', 'DE', 'FR', 'RU'].map((lang) => (
                    <button
                      key={lang}
                      onClick={() => {
                        onLanguageChange(lang);
                        setLangOpen(false);
                      }}
                      className={`w-full text-left px-2 py-1.5 text-sm transition duration-200 ${
                        language === lang 
                          ? 'bg-red-50 text-[#dc2626] font-medium' 
                          : 'text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      {lang}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Hamburger Menü */}
          <button 
            onClick={() => setOpen(!open)} 
            aria-label="menu" 
            className="p-3 rounded-lg hover:bg-gray-100 transition duration-300"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700">
              <path d="M3 12h18M3 6h18M3 18h18"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t bg-gray-50">
          <div className="flex flex-col px-6 py-4 gap-1">
            {['home','about','products','sectors','quality','contact'].map(p => (
              <button 
                key={p} 
                onClick={() => { onNavigate(p); setOpen(false); }} 
                className={`text-left py-3 px-4 rounded-lg transition duration-300 ${
                  current===p 
                    ? 'bg-red-100 text-[#dc2626] font-semibold' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {navLabel(p, language)}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}

function navLabel(key: string, language: string): string {
  return translations[language as keyof typeof translations]?.nav[key as keyof typeof translations.TR.nav] || key;
}

export default function App() {
  const [route, setRoute] = useState(getHashRoute());
  const [language, setLanguage] = useState('TR');
  
  useEffect(() => {
    const onHash = () => setRoute(getHashRoute());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  useEffect(() => {
    document.title = 'Efor Kablo - Silikon Bazlı Endüstriyel Çözümler';
    
    // Meta tags güncelleme
    updateMetaTags();
    
    // Structured data ekleme
    addStructuredData();
  }, [language]);

  function updateMetaTags() {
    const metaDescription = language === 'TR' 
      ? 'Efor Kablo - Silikon tabanlı endüstriyel ürünler, dış cephe fitilleri, beyaz eşya contaları ve özel silikon profiller üreticisi. ISO sertifikalı, yüksek kaliteli çözümler.'
      : language === 'EN'
      ? 'Efor Kablo - Manufacturer of silicon-based industrial products, facade seals, white goods gaskets and custom silicone profiles. ISO certified, high-quality solutions.'
      : language === 'DE'
      ? 'Efor Kablo - Hersteller von silikonbasierten Industrieerzeugnissen, Fassadendichtungen, Hausgerätedichtungen und maßgeschneiderten Silikonprofilen. ISO-zertifiziert, hochwertige Lösungen.'
      : language === 'FR'
      ? 'Efor Kablo - Fabricant de produits industriels à base de silicium, joints de façade, joints d\'électroménager et profils en silicone sur mesure. Solutions certifiées ISO, haute qualité.'
      : 'Efor Kablo - Производитель промышленных изделий на основе кремния, фасадных уплотнений, уплотнений бытовой техники и индивидуальных силиконовых профилей. ISO сертифицированные, высококачественные решения.';

    const metaKeywords = language === 'TR'
      ? 'silikon endüstriyel ürünler, dış cephe fitilleri, beyaz eşya contaları, silikon profiller, endüstriyel contalar, ISO sertifikalı, Türkiye üretici'
      : language === 'EN'
      ? 'silicon industrial products, facade seals, white goods gaskets, silicone profiles, industrial seals, ISO certified, Turkey manufacturer'
      : language === 'DE'
      ? 'Silikon-Industrieprodukte, Fassadendichtungen, Hausgerätedichtungen, Silikonprofile, Industriesiegel, ISO-zertifiziert, Türkei Hersteller'
      : language === 'FR'
      ? 'produits industriels en silicone, joints de façade, joints d\'électroménager, profils en silicone, joints industriels, certifié ISO, fabricant Turquie'
      : 'кремниевые промышленные изделия, фасадные уплотнения, уплотнения бытовой техники, силиконовые профили, промышленные уплотнения, сертифицировано ISO, производитель Турция';

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', metaDescription);

    // Meta keywords
    let metaKeywordsEl = document.querySelector('meta[name="keywords"]');
    if (!metaKeywordsEl) {
      metaKeywordsEl = document.createElement('meta');
      metaKeywordsEl.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywordsEl);
    }
    metaKeywordsEl.setAttribute('content', metaKeywords);

    // Open Graph tags
    updateOpenGraphTags(metaDescription);
  }

  function updateOpenGraphTags(description: string) {
    const ogTags = [
      { property: 'og:title', content: 'Efor Kablo - Silikon Bazlı Endüstriyel Çözümler' },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://eforkablo.com' },
      { property: 'og:image', content: 'https://eforkablo.com/efor_kablo_hero.jpg' },
      { property: 'og:site_name', content: 'Efor Kablo' },
      { property: 'og:locale', content: language === 'TR' ? 'tr_TR' : language === 'EN' ? 'en_US' : language === 'DE' ? 'de_DE' : language === 'FR' ? 'fr_FR' : 'ru_RU' }
    ];

    ogTags.forEach(tag => {
      let element = document.querySelector(`meta[property="${tag.property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', tag.content);
    });
  }

  function addStructuredData() {
    // Mevcut structured data'yı kaldır
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Efor Kablo Profil Ltd Şti",
      "alternateName": "Efor Kablo",
      "url": "https://eforkablo.com",
      "logo": "https://eforkablo.com/eforkablo_logo.png",
      "description": language === 'TR' 
        ? 'Silikon tabanlı endüstriyel ürünler, dış cephe fitilleri, beyaz eşya contaları ve özel silikon profiller üreticisi'
        : 'Manufacturer of silicon-based industrial products, facade seals, white goods gaskets and custom silicone profiles',
      "foundingDate": "2010",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "TR",
        "addressLocality": "Gaziosmanpaşa, İstanbul"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+90-212-123-45-67",
        "contactType": "customer service",
        "availableLanguage": ["Turkish", "English", "German", "French", "Russian"]
      },
      "sameAs": [
        "https://eforkablo.com"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": language === 'TR' ? 'Endüstriyel Ürünler' : 'Industrial Products',
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": language === 'TR' ? 'Dış Cephe Fitilleri' : 'Facade Seals',
              "description": language === 'TR' ? 'Alüminyum cephe, pencere ve kapı sistemleri için sızdırmazlık çözümleri' : 'Sealing solutions for aluminum facade, window and door systems'
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Product",
              "name": language === 'TR' ? 'Beyaz Eşya Contaları' : 'White Goods Gaskets',
              "description": language === 'TR' ? 'Ev aletleri üreticileri için özel sızdırmazlık çözümleri' : 'Specialized sealing solutions for household appliance manufacturers'
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product", 
              "name": language === 'TR' ? 'Silikon Profiller' : 'Silicone Profiles',
              "description": language === 'TR' ? 'Endüstriyel uygulamalar için özel silikon profil çözümleri' : 'Custom silicone profile solutions for industrial applications'
            }
          }
        ]
      },
      "award": [
        "ISO 9001:2015 Quality Management System",
        "ISO 14001:2015 Environmental Management System", 
        "ISO 45001:2018 Occupational Health and Safety Management System"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }

  function navigate(to: string) {
    window.location.hash = to === 'home' ? '' : to;
  }
  
  function changeLanguage(lang: string) {
    setLanguage(lang);
  }

  return (
    <div className={`${THEME.bg} min-h-screen text-[#111827]`}> 
      <Nav onNavigate={navigate} current={route} language={language} onLanguageChange={changeLanguage} />

      <main>
        {route === 'home' && <Home onNavigate={navigate} language={language} />}
        {route === 'about' && <About language={language} />}
        {route === 'products' && <Products language={language} />}
        {route === 'sectors' && <Sectors language={language} />}
        {route === 'quality' && <Quality language={language} />}
        {route === 'contact' && <Contact language={language} />}
      </main>

      <footer className="bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row justify-between items-start gap-8">
          <div>
            <img src="/eforkablo_logo_light.png" alt="Efor Kablo Logo" className="h-12 w-auto mb-4" />
            <p className="text-gray-300">
              {language === 'TR' && 'Silikon Bazlı Endüstriyel Çözümler'}
              {language === 'EN' && 'Silicone-Based Industrial Solutions'}
              {language === 'DE' && 'Silikonbasierte Industrielle Lösungen'}
              {language === 'FR' && 'Solutions Industrielles à Base de Silicone'}
              {language === 'RU' && 'Промышленные Решения на Основе Силикона'}
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-semibold mb-3">{footerTranslations[language as keyof typeof footerTranslations]?.products}</h4>
            <ul className="text-sm text-gray-300 space-y-2">
              <li><button onClick={() => navigate('products')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.facadeSeals}</button></li>
              <li><button onClick={() => navigate('products')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.whiteGoods}</button></li>
              <li><button onClick={() => navigate('products')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.siliconeProfiles}</button></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-3">{footerTranslations[language as keyof typeof footerTranslations]?.company}</h4>
            <ul className="text-sm text-gray-300 space-y-2">
              <li><button onClick={() => navigate('about')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.about}</button></li>
              <li><button onClick={() => navigate('quality')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.quality}</button></li>
              <li><button onClick={() => navigate('sectors')} className="hover:text-white transition duration-300">{footerTranslations[language as keyof typeof footerTranslations]?.sectors}</button></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="font-semibold mb-3">{footerTranslations[language as keyof typeof footerTranslations]?.contact}</h4>
            <ul className="text-sm text-gray-300 space-y-2">
              <li><a href="mailto:info@eforkablo.com" className="hover:text-white transition duration-300">info@eforkablo.com</a></li>
              <li><a href="tel:+902124750046" className="hover:text-white transition duration-300">+90 212 475 00 46</a></li>
              <li><a href="https://wa.me/905312130150" className="hover:text-white transition duration-300">+90 531 213 01 50 (Whatsapp)</a></li>
              <li>Karayolları Mah.<br />Kadir Akdoğan Cad. 561 Sok. No: 45<br />GAZİOSMANPAŞA / İSTANBUL / TÜRKİYE</li>
            </ul>
          </div>
          </div>
        </div>
        <div className="border-t border-gray-800">
          <div className="max-w-6xl mx-auto px-6 py-4 text-center text-sm text-gray-400">
            {footerTranslations[language as keyof typeof footerTranslations]?.copyright}
          </div>
        </div>
      </footer>
    </div>
  );
}

interface HomeProps {
  onNavigate: (route: string) => void;
  language: string;
}

function Home({ onNavigate, language }: HomeProps) {
  return (
    <section>
      {/* Hero Section - Full Width */}
      <div className="relative text-white py-24 w-full" style={{backgroundImage: 'url(/efor_kablo_hero.jpg)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4 sm:mb-6">
                  {translations[language as keyof typeof translations]?.home.hero.title1}<br />
                  <span className="text-blue-400">{translations[language as keyof typeof translations]?.home.hero.title2}</span> 
                  {translations[language as keyof typeof translations]?.home.hero.title3}
                </h1>
            <p className="text-lg sm:text-xl text-gray-300 mb-6 sm:mb-8 leading-relaxed max-w-4xl mx-auto">
              {translations[language as keyof typeof translations]?.home.hero.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => onNavigate('products')} 
                className="px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition duration-300 transform hover:scale-105 shadow-lg"
              >
                {translations[language as keyof typeof translations]?.home.hero.button1}
              </button>
              <button 
                onClick={() => onNavigate('contact')} 
                className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-lg transition duration-300"
              >
                {translations[language as keyof typeof translations]?.home.hero.button2}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
            <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">{translations[language as keyof typeof translations]?.home.features.title}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition duration-300 border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-green-600">
                <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">{translations[language as keyof typeof translations]?.home.features.prototype}</h3>
            <p className="text-gray-600">{translations[language as keyof typeof translations]?.home.features.prototypeDesc}</p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition duration-300 border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-blue-600">
                <circle cx="12" cy="12" r="10" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">{translations[language as keyof typeof translations]?.home.features.certified}</h3>
            <p className="text-gray-600">{translations[language as keyof typeof translations]?.home.features.certifiedDesc}</p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition duration-300 border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-red-600">
                <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">{translations[language as keyof typeof translations]?.home.features.eco}</h3>
            <p className="text-gray-600">{translations[language as keyof typeof translations]?.home.features.ecoDesc}</p>
          </div>
        </div>
      </div>

      {/* Product Categories */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
            <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">{translations[language as keyof typeof translations]?.home.categories.title}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <Card 
            title={translations[language as keyof typeof translations]?.home.categories.facade || "Dış Cephe Fitilleri"} 
            desc={translations[language as keyof typeof translations]?.home.categories.facadeDesc || "Enerji verimli ve UV dayanımlı sistemler"} 
            onClick={() => onNavigate('products')}
            language={language}
            icon={
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-blue-600">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="9,22 9,12 15,12 15,22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            }
          />
          <Card 
            title={translations[language as keyof typeof translations]?.home.categories.appliance || "Beyaz Eşya Contaları"} 
            desc={translations[language as keyof typeof translations]?.home.categories.applianceDesc || "Fırın ve bulaşık makinesi contalarında yüksek sızdırmazlık"} 
            onClick={() => onNavigate('products')}
            language={language}
            icon={
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-green-600">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="8" y1="21" x2="16" y2="21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="17" x2="12" y2="21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            }
          />
          <Card 
            title={translations[language as keyof typeof translations]?.home.categories.profiles || "Silikon Profiller"} 
            desc={translations[language as keyof typeof translations]?.home.categories.profilesDesc || "Özel kesit ve makaron çözümleri"} 
            onClick={() => onNavigate('products')}
            language={language}
            icon={
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-red-600">
                <circle cx="12" cy="12" r="3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            }
          />
        </div>
      </div>

      {/* CTA Section - Full Width */}
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white p-8 sm:p-12 text-center w-full">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4">{translations[language as keyof typeof translations]?.home.cta.title}</h2>
            <p className="text-lg sm:text-xl text-red-100 mb-6 sm:mb-8">{translations[language as keyof typeof translations]?.home.cta.description}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => onNavigate('contact')} 
            className="px-8 py-4 bg-white text-red-600 font-semibold rounded-lg hover:bg-gray-100 transition duration-300"
          >
            {translations[language as keyof typeof translations]?.home.cta.button1}
          </button>
        </div>
      </div>
    </section>
  );
}

interface CardProps {
  title: string;
  desc: string;
  onClick: () => void;
  icon: React.ReactNode;
  language: string;
}

function Card({ title, desc, onClick, icon, language }: CardProps) {
  return (
    <article className="p-8 bg-white border rounded-2xl shadow-lg hover:shadow-xl transition duration-300 cursor-pointer transform hover:scale-105" style={{borderColor: '#f5f5f5'}} onClick={onClick}>
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-gray-50 rounded-full flex items-center justify-center">
          {icon}
        </div>
        <h4 className="text-xl font-semibold mb-3">{title}</h4>
        <p className="text-gray-600 leading-relaxed">{desc}</p>
        <div className="mt-6">
          <span className="inline-flex items-center text-blue-600 font-medium">
            {translations[language as keyof typeof translations]?.home.cardButton}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="ml-2">
              <path d="M5 12h14M12 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
    </article>
  );
}

function About({ language }: { language: string }){
  return (
    <section>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-12 text-center w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-2">
        <h1 className="text-3xl font-bold mb-2">{translations[language as keyof typeof translations]?.nav.about}</h1>
        <p className="text-lg text-red-100">
          {language === 'TR' && '2012\'den bu yana silikon çözümlerinde uzman'}
          {language === 'EN' && 'Expert in silicone solutions since 2012'}
          {language === 'DE' && 'Experte für Silikonlösungen seit 2012'}
          {language === 'FR' && 'Expert en solutions silicone depuis 2012'}
          {language === 'RU' && 'Эксперт в силиконовых решениях с 2012 года'}
        </p>
      </div>

      {/* Company Story */}
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
        <div>
          <h2 className="text-3xl font-bold mb-6">
            {language === 'TR' && 'Hikayemiz'}
            {language === 'EN' && 'Our Story'}
            {language === 'DE' && 'Unsere Geschichte'}
            {language === 'FR' && 'Notre Histoire'}
            {language === 'RU' && 'Наша История'}
          </h2>
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              {language === 'TR' && 'Efor Kablo Profil Sanayi, 2012 yılından bu yana silikon bazlı kablo, conta ve profil üretiminde uzmanlaşmış bir üreticidir. -60°C ile +400°C arasındaki aşırı koşullara dayanıklı ürünler geliştiriyoruz.'}
              {language === 'EN' && 'Efor Kablo Profile Industry has been a manufacturer specialized in silicone-based cable, gasket and profile production since 2012. We develop products resistant to extreme conditions between -60°C and +400°C.'}
              {language === 'DE' && 'Efor Kablo Profil Industrie ist seit 2012 ein Hersteller, der sich auf die Produktion von silikonbasierten Kabeln, Dichtungen und Profilen spezialisiert hat. Wir entwickeln Produkte, die extremen Bedingungen zwischen -60°C und +400°C standhalten.'}
              {language === 'FR' && 'Efor Kablo Profile Industry est un fabricant spécialisé dans la production de câbles, joints et profils à base de silicone depuis 2012. Nous développons des produits résistants aux conditions extrêmes entre -60°C et +400°C.'}
              {language === 'RU' && 'Efor Kablo Profile Industry является производителем, специализирующимся на производстве силиконовых кабелей, прокладок и профилей с 2012 года. Мы разрабатываем продукты, устойчивые к экстремальным условиям от -60°C до +400°C.'}
            </p>
            <p>
              {language === 'TR' && 'Ar-Ge yatırımlarımız sayesinde müşteri ihtiyaçlarına özel silikon karışımları ve profiller üretmekteyiz. Kaliteyi; kapalı devre mixer sistemleri, otomasyon ve sıkı kalite kontrolleriyle sağlıyoruz.'}
              {language === 'EN' && 'Thanks to our R&D investments, we produce special silicone mixtures and profiles for customer needs. We ensure quality through closed-circuit mixer systems, automation and strict quality controls.'}
              {language === 'DE' && 'Dank unserer F&E-Investitionen produzieren wir spezielle Silikonmischungen und Profile für Kundenbedürfnisse. Wir gewährleisten Qualität durch geschlossene Mischsysteme, Automatisierung und strenge Qualitätskontrollen.'}
              {language === 'FR' && 'Grâce à nos investissements R&D, nous produisons des mélanges de silicone spéciaux et des profils pour les besoins des clients. Nous assurons la qualité grâce à des systèmes de mélange en circuit fermé, l\'automatisation et des contrôles qualité stricts.'}
              {language === 'RU' && 'Благодаря нашим инвестициям в НИОКР, мы производим специальные силиконовые смеси и профили для потребностей клиентов. Мы обеспечиваем качество через закрытые смесительные системы, автоматизацию и строгий контроль качества.'}
            </p>
            <p>
              {language === 'TR' && 'Ürünlerimiz beyaz eşyadan otomotive, inşaattan enerji sektörüne kadar geniş bir yelpazede kullanılmaktadır.'}
              {language === 'EN' && 'Our products are used in a wide range from white goods to automotive, from construction to energy sector.'}
              {language === 'DE' && 'Unsere Produkte werden in einem breiten Spektrum von Haushaltsgeräten bis zur Automobilindustrie, vom Bauwesen bis zum Energiesektor verwendet.'}
              {language === 'FR' && 'Nos produits sont utilisés dans un large éventail, des appareils électroménagers à l\'automobile, de la construction au secteur énergétique.'}
              {language === 'RU' && 'Наши продукты используются в широком спектре от бытовой техники до автомобилестроения, от строительства до энергетического сектора.'}
            </p>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-8 flex items-center justify-center">
          <div className="text-center">
            <div className="w-32 h-32 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-white">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">
              {language === 'TR' && '2012\'den Beri'}
              {language === 'EN' && 'Since 2012'}
              {language === 'DE' && 'Seit 2012'}
              {language === 'FR' && 'Depuis 2012'}
              {language === 'RU' && 'С 2012 года'}
            </h3>
            <p className="text-gray-600">
              {language === 'TR' && 'Silikon çözümlerinde deneyim'}
              {language === 'EN' && 'Experience in silicone solutions'}
              {language === 'DE' && 'Erfahrung in Silikonlösungen'}
              {language === 'FR' && 'Expérience en solutions silicone'}
              {language === 'RU' && 'Опыт в силиконовых решениях'}
            </p>
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="mb-16">
            <h2 className="text-3xl font-bold text-center mb-12">
              {language === 'TR' && 'Değerlerimiz'}
              {language === 'EN' && 'Our Values'}
              {language === 'DE' && 'Unsere Werte'}
              {language === 'FR' && 'Nos Valeurs'}
              {language === 'RU' && 'Наши Ценности'}
            </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-green-600">
                <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">
              {language === 'TR' && 'Kalite'}
              {language === 'EN' && 'Quality'}
              {language === 'DE' && 'Qualität'}
              {language === 'FR' && 'Qualité'}
              {language === 'RU' && 'Качество'}
            </h3>
            <p className="text-gray-600">
              {language === 'TR' && 'ISO 9001:2015 standartlarına uygun süreçler işletiyoruz.'}
              {language === 'EN' && 'We operate processes in accordance with ISO 9001:2015 standards.'}
              {language === 'DE' && 'Wir betreiben Prozesse gemäß ISO 9001:2015 Standards.'}
              {language === 'FR' && 'Nous opérons des processus conformes aux standards ISO 9001:2015.'}
              {language === 'RU' && 'Мы ведем процессы в соответствии со стандартами ISO 9001:2015.'}
            </p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-red-600">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">
              {language === 'TR' && 'İnovasyon'}
              {language === 'EN' && 'Innovation'}
              {language === 'DE' && 'Innovation'}
              {language === 'FR' && 'Innovation'}
              {language === 'RU' && 'Инновации'}
            </h3>
            <p className="text-gray-600">
              {language === 'TR' && 'Ar-Ge yatırımlarımızla sürekli gelişim sağlıyoruz.'}
              {language === 'EN' && 'We ensure continuous development with our R&D investments.'}
              {language === 'DE' && 'Wir gewährleisten kontinuierliche Entwicklung durch unsere F&E-Investitionen.'}
              {language === 'FR' && 'Nous assurons un développement continu grâce à nos investissements R&D.'}
              {language === 'RU' && 'Мы обеспечиваем непрерывное развитие благодаря нашим инвестициям в НИОКР.'}
            </p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-2xl shadow-lg border" style={{borderColor: '#f5f5f5'}}>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-red-600">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-4">
              {language === 'TR' && 'Sürdürülebilirlik'}
              {language === 'EN' && 'Sustainability'}
              {language === 'DE' && 'Nachhaltigkeit'}
              {language === 'FR' && 'Durabilité'}
              {language === 'RU' && 'Устойчивость'}
            </h3>
            <p className="text-gray-600">
              {language === 'TR' && 'Çevreye duyarlı üretim ve enerji verimliliği.'}
              {language === 'EN' && 'Environmentally conscious production and energy efficiency.'}
              {language === 'DE' && 'Umweltbewusste Produktion und Energieeffizienz.'}
              {language === 'FR' && 'Production respectueuse de l\'environnement et efficacité énergétique.'}
              {language === 'RU' && 'Экологически сознательное производство и энергоэффективность.'}
            </p>
          </div>
        </div>
      </div>

      {/* Mission */}
      <div className="bg-gray-50 rounded-2xl p-12 text-center">
        <h2 className="text-3xl font-bold mb-6">
          {language === 'TR' && 'Misyonumuz'}
          {language === 'EN' && 'Our Mission'}
          {language === 'DE' && 'Unsere Mission'}
          {language === 'FR' && 'Notre Mission'}
          {language === 'RU' && 'Наша Миссия'}
        </h2>
        <p className="text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
          {language === 'TR' && 'Bizimle çalışmak, sadece ürün almak değil; teknik danışmanlıkla süreçlerinizi optimize etmek demektir. Çevreye duyarlı üretimimizde atıkları geri dönüştürüyor, enerji verimliliği hedefliyor ve ISO 9001:2015 standartlarına uygun süreçler işletiyoruz.'}
          {language === 'EN' && 'Working with us means not just buying products, but optimizing your processes with technical consultancy. In our environmentally conscious production, we recycle waste, aim for energy efficiency and operate processes in accordance with ISO 9001:2015 standards.'}
          {language === 'DE' && 'Mit uns zu arbeiten bedeutet nicht nur Produkte zu kaufen, sondern Ihre Prozesse durch technische Beratung zu optimieren. In unserer umweltbewussten Produktion recyceln wir Abfälle, streben nach Energieeffizienz und betreiben Prozesse gemäß ISO 9001:2015 Standards.'}
          {language === 'FR' && 'Travailler avec nous ne signifie pas seulement acheter des produits, mais optimiser vos processus avec des conseils techniques. Dans notre production respectueuse de l\'environnement, nous recyclons les déchets, visons l\'efficacité énergétique et opérons des processus conformes aux standards ISO 9001:2015.'}
          {language === 'RU' && 'Работать с нами означает не просто покупать продукты, а оптимизировать ваши процессы с помощью технических консультаций. В нашем экологически сознательном производстве мы перерабатываем отходы, стремимся к энергоэффективности и ведем процессы в соответствии со стандартами ISO 9001:2015.'}
        </p>
      </div>
      </div>
    </section>
  );
}

function Products({ language }: { language: string }){
  return (
    <section>
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-12 text-center w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-2">
        <h1 className="text-3xl font-bold mb-2">{translations[language as keyof typeof translations]?.nav.products}</h1>
        <p className="text-lg text-red-100">
          {language === 'TR' && 'Silikon bazlı endüstriyel çözümler'}
          {language === 'EN' && 'Silicone-based industrial solutions'}
          {language === 'DE' && 'Silikonbasierte industrielle Lösungen'}
          {language === 'FR' && 'Solutions industrielles à base de silicone'}
          {language === 'RU' && 'Промышленные решения на основе силикона'}
        </p>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <p className="text-gray-600 mt-2 text-sm sm:text-base">
          {language === 'TR' && 'Aşağıda Efor Kablo\'nun ana ürün kategorileri ve alt ürünleri yer almaktadır. Her ürün için teknik detaylar ve uygulama alanları belirtilmiştir.'}
          {language === 'EN' && 'Below are Efor Kablo\'s main product categories and sub-products. Technical details and application areas are specified for each product.'}
          {language === 'DE' && 'Unten sind Efor Kablos Hauptproduktkategorien und Unterprodukte aufgeführt. Für jedes Produkt sind technische Details und Anwendungsbereiche angegeben.'}
          {language === 'FR' && 'Ci-dessous se trouvent les principales catégories de produits et sous-produits d\'Efor Kablo. Les détails techniques et domaines d\'application sont spécifiés pour chaque produit.'}
          {language === 'RU' && 'Ниже представлены основные категории продуктов и подпродукты Efor Kablo. Для каждого продукта указаны технические детали и области применения.'}
        </p>

        <div className="mt-6 sm:mt-8 space-y-8 sm:space-y-12">
          {/* Dış Cephe Fitilleri Kategorisi */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/dis_cephe_fitilleri.jpg" 
                  alt="Dış Cephe Fitilleri"
                  className="w-full h-full object-cover"
                />
                  </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {language === 'TR' && 'Dış Cephe Fitilleri'}
                  {language === 'EN' && 'Facade Seals'}
                  {language === 'DE' && 'Fassadendichtungen'}
                  {language === 'FR' && 'Joints de Façade'}
                  {language === 'RU' && 'Фасадные Уплотнения'}
                </h2>
                <p className="text-gray-600 mb-6">
                  {language === 'TR' && 'Enerji verimli ve UV dayanımlı sistemler'}
                  {language === 'EN' && 'Energy efficient and UV resistant systems'}
                  {language === 'DE' && 'Energieeffiziente und UV-beständige Systeme'}
                  {language === 'FR' && 'Systèmes efficaces et résistants aux UV'}
                  {language === 'RU' && 'Энергоэффективные и УФ-стойкие системы'}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Silikon Dış Cephe Fitilleri'}
                      {language === 'EN' && 'Silicone Facade Seals'}
                      {language === 'DE' && 'Silikon-Fassadendichtungen'}
                      {language === 'FR' && 'Joints de Façade Silicone'}
                      {language === 'RU' && 'Силиконовые Фасадные Уплотнения'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'UV dayanımlı, su sızdırmazlık'}
                      {language === 'EN' && 'UV resistant, waterproof'}
                      {language === 'DE' && 'UV-beständig, wasserdicht'}
                      {language === 'FR' && 'Résistant aux UV, étanche'}
                      {language === 'RU' && 'УФ-стойкий, водонепроницаемый'}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Silikon Köşe Baskı Contası'}
                      {language === 'EN' && 'Silicone Corner Compression Gasket'}
                      {language === 'DE' && 'Silikon-Eckendruckdichtung'}
                      {language === 'FR' && 'Joint de Compression d\'Angle Silicone'}
                      {language === 'RU' && 'Силиконовая Угловая Компрессионная Прокладка'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Köşe birleşim noktaları için özel tasarım'}
                      {language === 'EN' && 'Special design for corner connection points'}
                      {language === 'DE' && 'Spezielles Design für Eckverbindungspunkte'}
                      {language === 'FR' && 'Design spécial pour les points de connexion d\'angle'}
                      {language === 'RU' && 'Специальный дизайн для угловых точек соединения'}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'EPDM Köşe Baskı Contası'}
                      {language === 'EN' && 'EPDM Corner Compression Gasket'}
                      {language === 'DE' && 'EPDM-Eckendruckdichtung'}
                      {language === 'FR' && 'Joint de Compression d\'Angle EPDM'}
                      {language === 'RU' && 'EPDM Угловая Компрессионная Прокладка'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'EPDM malzeme ile köşe uygulamaları'}
                      {language === 'EN' && 'Corner applications with EPDM material'}
                      {language === 'DE' && 'Eckanwendungen mit EPDM-Material'}
                      {language === 'FR' && 'Applications d\'angle avec matériau EPDM'}
                      {language === 'RU' && 'Угловые применения с материалом EPDM'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Beyaz Eşya Yan Sanayi Ürünleri Kategorisi */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/beyaz_esya_fitilleri.jpg" 
                  alt="Beyaz Eşya Yan Sanayi"
                  className="w-full h-full object-cover"
                />
                  </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {language === 'TR' && 'Beyaz Eşya Yan Sanayi Ürünleri'}
                  {language === 'EN' && 'White Goods Industry Products'}
                  {language === 'DE' && 'Haushaltsgeräte-Industrieprodukte'}
                  {language === 'FR' && 'Produits de l\'Industrie Électroménager'}
                  {language === 'RU' && 'Продукты Промышленности Бытовой Техники'}
                </h2>
                <p className="text-gray-600 mb-6">
                  {language === 'TR' && 'Fırın ve bulaşık makinesi contalarında yüksek sızdırmazlık'}
                  {language === 'EN' && 'High sealing performance in oven and dishwasher gaskets'}
                  {language === 'DE' && 'Hohe Dichtleistung bei Ofen- und Geschirrspülmaschinen-Dichtungen'}
                  {language === 'FR' && 'Haute performance d\'étanchéité dans les joints de four et lave-vaisselle'}
                  {language === 'RU' && 'Высокая герметичность в прокладках духовок и посудомоечных машин'}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Fırın Kapak Contası'}
                      {language === 'EN' && 'Oven Door Gasket'}
                      {language === 'DE' && 'Ofentür-Dichtung'}
                      {language === 'FR' && 'Joint de Porte de Four'}
                      {language === 'RU' && 'Уплотнение Дверцы Духовки'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Yüksek sıcaklık dayanımı, FDA onaylı'}
                      {language === 'EN' && 'High temperature resistance, FDA approved'}
                      {language === 'DE' && 'Hohe Temperaturbeständigkeit, FDA-zugelassen'}
                      {language === 'FR' && 'Résistance à haute température, approuvé FDA'}
                      {language === 'RU' && 'Высокая термостойкость, одобрено FDA'}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Ankastre Fırın Izgara Contaları'}
                      {language === 'EN' && 'Built-in Oven Rack Gaskets'}
                      {language === 'DE' && 'Einbau-Ofen-Rost-Dichtungen'}
                      {language === 'FR' && 'Joints de Grille de Four Intégré'}
                      {language === 'RU' && 'Уплотнения Решетки Встроенной Духовки'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Ankastre fırınlar için özel tasarım'}
                      {language === 'EN' && 'Special design for built-in ovens'}
                      {language === 'DE' && 'Spezielles Design für Einbauöfen'}
                      {language === 'FR' && 'Design spécial pour fours intégrés'}
                      {language === 'RU' && 'Специальный дизайн для встроенных духовок'}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Silikon Makaronlar'}
                      {language === 'EN' && 'Silicone Macarons'}
                      {language === 'DE' && 'Silikon-Makronen'}
                      {language === 'FR' && 'Macarons Silicone'}
                      {language === 'RU' && 'Силиконовые Макароны'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Beyaz eşya uygulamaları için makaron çözümleri'}
                      {language === 'EN' && 'Macaron solutions for white goods applications'}
                      {language === 'DE' && 'Makronen-Lösungen für Haushaltsgeräte-Anwendungen'}
                      {language === 'FR' && 'Solutions macaron pour applications électroménager'}
                      {language === 'RU' && 'Макаронные решения для применения в бытовой технике'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Endüstriyel Fırın Ürünleri Kategorisi */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/endustriyelfirinfitilleri.jpg" 
                  alt="Endüstriyel Fırın"
                  className="w-full h-full object-cover"
                />
                  </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {language === 'TR' && 'Endüstriyel Fırın Ürünleri'}
                  {language === 'EN' && 'Industrial Oven Products'}
                  {language === 'DE' && 'Industrieofen-Produkte'}
                  {language === 'FR' && 'Produits de Four Industriel'}
                  {language === 'RU' && 'Продукты Промышленной Печи'}
                </h2>
                <p className="text-gray-600 mb-6">
                  {language === 'TR' && 'Yüksek sıcaklık uygulamaları için özel çözümler'}
                  {language === 'EN' && 'Special solutions for high temperature applications'}
                  {language === 'DE' && 'Spezielle Lösungen für Hochtemperaturanwendungen'}
                  {language === 'FR' && 'Solutions spéciales pour applications haute température'}
                  {language === 'RU' && 'Специальные решения для высокотемпературных применений'}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {language === 'TR' && 'Endüstriyel Silikon Kapak Contaları'}
                      {language === 'EN' && 'Industrial Silicone Door Gaskets'}
                      {language === 'DE' && 'Industrielle Silikon-Türdichtungen'}
                      {language === 'FR' && 'Joints de Porte Silicone Industriels'}
                      {language === 'RU' && 'Промышленные Силиконовые Уплотнения Дверей'}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Endüstriyel fırınlar için yüksek sıcaklık dayanımlı contalar'}
                      {language === 'EN' && 'High temperature resistant gaskets for industrial ovens'}
                      {language === 'DE' && 'Hochtemperaturbeständige Dichtungen für Industrieöfen'}
                      {language === 'FR' && 'Joints résistants à haute température pour fours industriels'}
                      {language === 'RU' && 'Термостойкие уплотнения для промышленных печей'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


function Sectors({ language }: { language: string }){
  return (
    <section>
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-12 text-center w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-2">
        <h1 className="text-3xl font-bold mb-2">{translations[language as keyof typeof translations]?.nav.sectors}</h1>
        <p className="text-lg text-red-100">
          {language === 'TR' && 'Farklı sektörler için özel çözümler'}
          {language === 'EN' && 'Special solutions for different sectors'}
          {language === 'DE' && 'Spezielle Lösungen für verschiedene Sektoren'}
          {language === 'FR' && 'Solutions spéciales pour différents secteurs'}
          {language === 'RU' && 'Специальные решения для различных секторов'}
        </p>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <p className="mt-3 text-gray-700 text-sm sm:text-base">
          {language === 'TR' && 'Efor Kablo ürünleri, farklı sektörlerin teknik taleplerine uygun olarak tasarlanır ve üretilir. Aşağıda başlıca sektörler ve tipik kullanım alanları detaylı olarak listelenmiştir.'}
          {language === 'EN' && 'Efor Kablo products are designed and manufactured according to the technical requirements of different sectors. Below are the main sectors and typical usage areas listed in detail.'}
          {language === 'DE' && 'Efor Kablo Produkte werden entsprechend den technischen Anforderungen verschiedener Sektoren entworfen und hergestellt. Unten sind die Hauptsektoren und typischen Anwendungsbereiche detailliert aufgeführt.'}
          {language === 'FR' && 'Les produits Efor Kablo sont conçus et fabriqués selon les exigences techniques de différents secteurs. Ci-dessous sont listés en détail les principaux secteurs et domaines d\'utilisation typiques.'}
          {language === 'RU' && 'Продукты Efor Kablo разрабатываются и производятся в соответствии с техническими требованиями различных секторов. Ниже подробно перечислены основные секторы и типичные области применения.'}
        </p>

        <div className="mt-6 sm:mt-8 space-y-8 sm:space-y-12">
          {/* Beyaz Eşya Sektörü */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/beyaz_esya_sectors.jpeg" 
                  alt="Beyaz Eşya Sektörü"
                  className="w-full h-full object-cover"
                />
                  </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.whiteGoodsSector}
                </h2>
                <p className="text-gray-600 mb-6">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.whiteGoodsDesc}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.ovenDoorGaskets}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.ovenDoorDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.dishwasherGaskets}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.dishwasherDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.washingMachineGaskets}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.washingMachineDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.refrigeratorGaskets}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.refrigeratorDesc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* İnşaat & Cephe Sektörü */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/dis_cephe_sectors.jpg" 
                  alt="İnşaat & Cephe Sektörü"
                  className="w-full h-full object-cover"
                />
                </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.constructionSector}
                </h2>
                <p className="text-gray-600 mb-6">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.constructionDesc}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.aluminumFacade}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.aluminumFacadeDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.historicalRestoration}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.historicalRestorationDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.windowSystems}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.windowSystemsDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.doorSystems}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.doorSystemsDesc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Enerji & Otomotiv Sektörü */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/enerji_sectors.jpg" 
                  alt="Enerji & Otomotiv Sektörü"
                  className="w-full h-full object-cover"
                />
                </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.energySector}
                </h2>
                <p className="text-gray-600 mb-6">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.energyDesc}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.industrialOvens}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.industrialOvensDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.automotiveMotor}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.automotiveMotorDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.powerPlants}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.powerPlantsDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.petrochemical}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.petrochemicalDesc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Gıda & İlaç Sektörü */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-8 border" style={{borderColor: '#f5f5f5'}}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6">
              <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img 
                  src="/saglik_sectors.jpg" 
                  alt="Gıda & İlaç Sektörü"
                  className="w-full h-full object-cover"
                />
                </div>
              <div className="flex-1 w-full text-center sm:text-left">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.foodSector}
                </h2>
                <p className="text-gray-600 mb-6">
                  {sectorsTranslations[language as keyof typeof sectorsTranslations]?.foodDesc}
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.foodProcessing}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.foodProcessingDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.pharmaceutical}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.pharmaceuticalDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.laboratory}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.laboratoryDesc}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.packaging}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {sectorsTranslations[language as keyof typeof sectorsTranslations]?.packagingDesc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


function Quality({ language }: { language: string }){
  return (
    <section>
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-12 text-center w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-2">
        <h1 className="text-3xl font-bold mb-2">{translations[language as keyof typeof translations]?.nav.quality}</h1>
        <p className="text-lg text-red-100">
          {language === 'TR' && 'Kalite standartlarımız ve sertifikalarımız'}
          {language === 'EN' && 'Our quality standards and certificates'}
          {language === 'DE' && 'Unsere Qualitätsstandards und Zertifikate'}
          {language === 'FR' && 'Nos standards de qualité et certificats'}
          {language === 'RU' && 'Наши стандарты качества и сертификаты'}
        </p>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-6">
        <p className="mt-3 text-gray-700">
          {language === 'TR' && 'Efor Kablo, üretim süreçlerinde kaliteyi ön planda tutar. Aşağıdaki standartlara uygun üretim gerçekleştirilmektedir.'}
          {language === 'EN' && 'Efor Kablo prioritizes quality in production processes. Production is carried out in accordance with the following standards.'}
          {language === 'DE' && 'Efor Kablo priorisiert Qualität in den Produktionsprozessen. Die Produktion erfolgt gemäß den folgenden Standards.'}
          {language === 'FR' && 'Efor Kablo privilégie la qualité dans les processus de production. La production est réalisée conformément aux standards suivants.'}
          {language === 'RU' && 'Efor Kablo приоритизирует качество в производственных процессах. Производство осуществляется в соответствии со следующими стандартами.'}
        </p>

        {/* Sertifika Görselleri */}
        <div className="mt-8">
          {/* 3 ISO Sertifikası */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="rounded-lg aspect-[3/4] overflow-hidden shadow-lg border" style={{borderColor: '#f5f5f5'}}>
              <img src="/ISO9001.jpg" alt="ISO 9001:2015 Sertifikası" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-lg aspect-[3/4] overflow-hidden shadow-lg border" style={{borderColor: '#f5f5f5'}}>
              <img src="/ISO14001.jpg" alt="ISO 14001:2015 Sertifikası" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-lg aspect-[3/4] overflow-hidden shadow-lg border" style={{borderColor: '#f5f5f5'}}>
              <img src="/ISO45001.jpg" alt="ISO 45001:2018 Sertifikası" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div className="mt-8 p-5 bg-gray-50 rounded-xl">
          <h4 className="font-semibold">
            {qualityTranslations[language as keyof typeof qualityTranslations]?.productionQualityControl}
          </h4>
          <p className="text-gray-700 mt-2">
            {qualityTranslations[language as keyof typeof qualityTranslations]?.qualityControlDesc}
          </p>
        </div>
      </div>
    </section>
  );
}

function Contact({ language }: { language: string }){
  const [state, setState] = useState({ name:'', email:'', message:'', captcha:'' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [captchaQuestion, setCaptchaQuestion] = useState({ num1: 0, num2: 0, answer: 0 });

  // Captcha oluştur
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptchaQuestion({ num1, num2, answer: num1 + num2 });
  };

  // Component mount olduğunda captcha oluştur
  useEffect(() => {
    generateCaptcha();
  }, []);

  async function submit(e: React.FormEvent){
    e.preventDefault();
    setLoading(true);
    setError('');
    
    // Captcha kontrolü
    if (parseInt(state.captcha) !== captchaQuestion.answer) {
      setError('Güvenlik sorusunu yanlış cevapladınız. Lütfen tekrar deneyin.');
      setLoading(false);
      generateCaptcha(); // Yeni captcha oluştur
      return;
    }
    
    try {
      console.log('Form gönderiliyor...', { name: state.name, email: state.email });
      
      // Firebase Firestore'a mesajı kaydet
      console.log('Firebase\'e kaydediliyor...');
      await addDoc(collection(db, 'contactMessages'), {
        name: state.name,
        email: state.email,
        message: state.message,
        language: language,
        timestamp: serverTimestamp(),
        createdAt: new Date().toISOString()
      });
      console.log('Firebase\'e kaydedildi');

      // Email.js ile email gönder
      console.log('Email gönderiliyor...');
      const templateParams = {
        from_name: state.name,
        from_email: state.email,
        message: state.message,
        language: language,
        date: new Date().toLocaleString('tr-TR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }),
        to_email: 'ozcan.er@eforkablo.com,ermanozkaya@gmail.com'
      };

      console.log('Template parametreleri:', templateParams);

      // Email.js servisini başlat (public key ile)
      emailjs.init('GY9snZXZnUj8sQVfx');
      
      // Email gönder
      const emailResult = await emailjs.send(
        'service_an057kh',
        'template_ju8j3oh',
        templateParams
      );
      
      console.log('Email gönderildi:', emailResult);
      
    setSent(true);
      setState({ name: '', email: '', message: '', captcha: '' });
      generateCaptcha(); // Yeni captcha oluştur
    setTimeout(() => setSent(false), 5000);
    } catch (err: any) {
      console.error('Detaylı hata:', err);
      console.error('Hata mesajı:', err?.message || 'Bilinmeyen hata');
      console.error('Hata kodu:', err?.status || 'Bilinmeyen kod');
      setError(`Mesaj gönderilirken bir hata oluştu: ${err?.message || 'Bilinmeyen hata'}`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <section>
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-12 text-center w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-2">
        <h1 className="text-3xl font-bold mb-2">{translations[language as keyof typeof translations]?.nav.contact}</h1>
        <p className="text-lg text-red-100">
          {language === 'TR' && 'Bizimle iletişime geçin'}
          {language === 'EN' && 'Contact us'}
          {language === 'DE' && 'Kontaktieren Sie uns'}
          {language === 'FR' && 'Contactez-nous'}
          {language === 'RU' && 'Свяжитесь с нами'}
        </p>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="mt-4 grid md:grid-cols-2 gap-8">
        <div>
          <p className="text-gray-700">
            {language === 'TR' && 'Sorularınız ve proje talepleriniz için aşağıdaki formu kullanabilirsiniz.'}
            {language === 'EN' && 'You can use the form below for your questions and project requests.'}
            {language === 'DE' && 'Sie können das untenstehende Formular für Ihre Fragen und Projektanfragen verwenden.'}
            {language === 'FR' && 'Vous pouvez utiliser le formulaire ci-dessous pour vos questions et demandes de projet.'}
            {language === 'RU' && 'Вы можете использовать форму ниже для ваших вопросов и запросов проектов.'}
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-sm text-gray-700">
                {language === 'TR' && 'İsim'}
                {language === 'EN' && 'Name'}
                {language === 'DE' && 'Name'}
                {language === 'FR' && 'Nom'}
                {language === 'RU' && 'Имя'}
              </span>
              <input required value={state.name} onChange={e => setState({...state, name: e.target.value})} className="mt-1 block w-full border rounded-md p-2" />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">
                {language === 'TR' && 'E-mail'}
                {language === 'EN' && 'E-mail'}
                {language === 'DE' && 'E-Mail'}
                {language === 'FR' && 'E-mail'}
                {language === 'RU' && 'Электронная почта'}
              </span>
              <input required type="email" value={state.email} onChange={e => setState({...state, email: e.target.value})} className="mt-1 block w-full border rounded-md p-2" />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">
                {language === 'TR' && 'Mesaj'}
                {language === 'EN' && 'Message'}
                {language === 'DE' && 'Nachricht'}
                {language === 'FR' && 'Message'}
                {language === 'RU' && 'Сообщение'}
              </span>
              <textarea required value={state.message} onChange={e => setState({...state, message: e.target.value})} rows={5} className="mt-1 block w-full border rounded-md p-2" />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">
                {language === 'TR' && `Güvenlik Sorusu: ${captchaQuestion.num1} + ${captchaQuestion.num2} = ?`}
                {language === 'EN' && `Security Question: ${captchaQuestion.num1} + ${captchaQuestion.num2} = ?`}
                {language === 'DE' && `Sicherheitsfrage: ${captchaQuestion.num1} + ${captchaQuestion.num2} = ?`}
                {language === 'FR' && `Question de sécurité: ${captchaQuestion.num1} + ${captchaQuestion.num2} = ?`}
                {language === 'RU' && `Вопрос безопасности: ${captchaQuestion.num1} + ${captchaQuestion.num2} = ?`}
              </span>
              <input 
                required 
                type="number" 
                value={state.captcha} 
                onChange={e => setState({...state, captcha: e.target.value})} 
                className="mt-1 block w-full border rounded-md p-2" 
                placeholder={language === 'TR' ? 'Cevabınızı girin' : 'Enter your answer'}
              />
            </label>

            <div>
              <button 
                className={`px-4 py-2 text-white rounded-md transition duration-300 ${
                  loading 
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-[#2B2B2B] hover:bg-gray-800'
                }`} 
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {language === 'TR' && 'Gönderiliyor...'}
                    {language === 'EN' && 'Sending...'}
                    {language === 'DE' && 'Wird gesendet...'}
                    {language === 'FR' && 'Envoi en cours...'}
                    {language === 'RU' && 'Отправка...'}
                  </span>
                ) : (
                  <>
                {language === 'TR' && 'Gönder'}
                {language === 'EN' && 'Send'}
                {language === 'DE' && 'Senden'}
                {language === 'FR' && 'Envoyer'}
                {language === 'RU' && 'Отправить'}
                  </>
                )}
              </button>
              
              {sent && (
                <div className="mt-3 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
                  {language === 'TR' && '✅ Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.'}
                  {language === 'EN' && '✅ Your message has been sent successfully! We will get back to you soon.'}
                  {language === 'DE' && '✅ Ihre Nachricht wurde erfolgreich gesendet! Wir werden uns bald bei Ihnen melden.'}
                  {language === 'FR' && '✅ Votre message a été envoyé avec succès ! Nous vous répondrons bientôt.'}
                  {language === 'RU' && '✅ Ваше сообщение успешно отправлено! Мы скоро свяжемся с вами.'}
                </div>
              )}
              
              {error && (
                <div className="mt-3 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                  {error}
                </div>
              )}
            </div>
          </form>
        </div>

        <div>
          <div className="bg-white p-6 border rounded-xl">
                <h4 className="font-semibold mb-4">
                  {language === 'TR' && 'İletişim Bilgileri'}
                  {language === 'EN' && 'Contact Information'}
                  {language === 'DE' && 'Kontaktinformationen'}
                  {language === 'FR' && 'Informations de Contact'}
                  {language === 'RU' && 'Контактная Информация'}
                </h4>
            
            <div className="space-y-4">
              <div>
                <h5 className="font-semibold text-sm text-gray-800 mb-2">
                  {language === 'TR' && 'Adres'}
                  {language === 'EN' && 'Address'}
                  {language === 'DE' && 'Adresse'}
                  {language === 'FR' && 'Adresse'}
                  {language === 'RU' && 'Адрес'}
                </h5>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45<br />
                  Sultangazi / İSTANBUL
                </p>
              </div>

              <div>
                <h5 className="font-semibold text-sm text-gray-800 mb-2">
                  {language === 'TR' && 'Telefon'}
                  {language === 'EN' && 'Phone'}
                  {language === 'DE' && 'Telefon'}
                  {language === 'FR' && 'Téléphone'}
                  {language === 'RU' && 'Телефон'}
                </h5>
                <p className="text-sm text-gray-600">
                  <a href="tel:+902124750046" className="text-blue-600 hover:text-blue-800 transition duration-300">+90 212 475 00 46</a>
                </p>
              </div>

              <div>
                <h5 className="font-semibold text-sm text-gray-800 mb-2">
                  {language === 'TR' && 'GSM & Whatsapp'}
                  {language === 'EN' && 'GSM & Whatsapp'}
                  {language === 'DE' && 'GSM & Whatsapp'}
                  {language === 'FR' && 'GSM & Whatsapp'}
                  {language === 'RU' && 'GSM & Whatsapp'}
                </h5>
                <p className="text-sm text-gray-600">
                  <a href="https://wa.me/905312130150" className="text-green-600 hover:text-green-800 transition duration-300">+90 531 213 01 50</a>
                </p>
              </div>

              <div>
                <h5 className="font-semibold text-sm text-gray-800 mb-2">
                  {language === 'TR' && 'E-posta'}
                  {language === 'EN' && 'E-mail'}
                  {language === 'DE' && 'E-Mail'}
                  {language === 'FR' && 'E-mail'}
                  {language === 'RU' && 'Электронная почта'}
                </h5>
                <p className="text-sm text-gray-600">
                  <a href="mailto:info@eforkablo.com" className="text-blue-600 hover:text-blue-800 transition duration-300">info@eforkablo.com</a>
                </p>
              </div>

              <div className="mt-4">
                    <h5 className="font-semibold text-sm text-gray-800 mb-2">
                      {language === 'TR' && 'Çalışma Saatleri'}
                      {language === 'EN' && 'Working Hours'}
                      {language === 'DE' && 'Arbeitszeiten'}
                      {language === 'FR' && 'Heures de Travail'}
                      {language === 'RU' && 'Рабочие Часы'}
                    </h5>
                    <p className="text-sm text-gray-600">
                      {language === 'TR' && 'Pazartesi - Cuma: 09:00 - 17:00'}
                      {language === 'EN' && 'Monday - Friday: 09:00 - 17:00'}
                      {language === 'DE' && 'Montag - Freitag: 09:00 - 17:00'}
                      {language === 'FR' && 'Lundi - Vendredi: 09:00 - 17:00'}
                      {language === 'RU' && 'Понедельник - Пятница: 09:00 - 17:00'}
                    </p>
              </div>
            </div>

            <div className="mt-6">
              <h5 className="font-semibold text-sm text-gray-800 mb-2">
                {language === 'TR' && 'Konum'}
                {language === 'EN' && 'Location'}
                {language === 'DE' && 'Standort'}
                {language === 'FR' && 'Localisation'}
                {language === 'RU' && 'Местоположение'}
              </h5>
              <div className="mt-2 w-full h-64 rounded-lg overflow-hidden">
                <iframe
                  src="https://maps.google.com/maps?q=41.084740,28.906503&hl=tr&z=15&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Efor Kablo Konumu"
                ></iframe>
              </div>
              <p className="text-xs text-gray-500 mt-2">
                {language === 'TR' && 'Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45, Gaziosmanpaşa/İstanbul'}
                {language === 'EN' && 'Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45, Gaziosmanpaşa/Istanbul'}
                {language === 'DE' && 'Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45, Gaziosmanpaşa/Istanbul'}
                {language === 'FR' && 'Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45, Gaziosmanpaşa/Istanbul'}
                {language === 'RU' && 'Karayolları Mah. Kadir Akdoğan Cad. 561 Sok. No: 45, Gaziosmanpaşa/Стамбул'}
              </p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}

function getHashRoute(): string {
  const h = window.location.hash.replace('#','');
  return h === '' ? 'home' : h;
}